import React from "react";
import Banner from "../../components/Banner";
import { Sidebar } from "../../components/Sidebar";
import axios from "axios";
import Spinner from "../../components/Spinner";
import { Modal } from "../../components/Modal";

const API = localStorage.getItem("assethost");

export default class SearchAssetLaw extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      valid: true,
      msg: "",
      toastColor: "",
      assets: [],
      category: "",
      uniqueIdentifier: "",
      assetFile: null,
      categories: [],
      searchCost: null,
      errors: {},
      companyProfileId: sessionStorage.getItem("companyProfileId") || "0",
      individualProfileId: sessionStorage.getItem("individualProfileId") || "0",
      showPrintModal: false,
      printData: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleUploadSearch = this.handleUploadSearch.bind(this);
    this.validate = this.validate.bind(this);
    this.loadCategories = this.loadCategories.bind(this);
    this.handlePrint = this.handlePrint.bind(this);
  }

  componentDidMount() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }
    this.loadCategories(token);
  }

  loadCategories(token) {
    this.setState({ loading: true, msg: "", toastColor: "" });
    const individualProfileId =
      sessionStorage.getItem("individualProfileId") || "0";
    const companyProfileId = sessionStorage.getItem("companyProfileId") || "0";

    axios
      .get(
        API +
          `/asset/getassetgenericsearchdropdownlist/${individualProfileId}/${companyProfileId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        const data = response.data || {};
        this.setState({
          categories: data.categories || [],
          searchCost: data.searchCost || null,
          loading: false,
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          loading: false,
          msg: error?.response?.data?.message || "Failed to load categories.",
          toastColor: "danger",
        });
      });
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value }, this.validate);
  }

  handleFileChange(e) {
    const { name } = e.target;
    const file = e.target.files ? e.target.files[0] : null;
    this.setState({ [name]: file }, this.validate);
  }

  validate() {
    // const s = this.state;
    let errors = {};
    let valid = true;

    // if (!s.category && !s.uniqueIdentifier && !s.assetFile) {
    //   errors.search = "At least one search criteria is required";
    //   valid = false;
    // }

    this.setState({ errors, valid });
    return valid;
  }

  handleSearch(e) {
    e.preventDefault();
    if (!this.validate()) {
      this.setState({
        msg: "Fix the errors above and try again.",
        toastColor: "danger",
      });
      return;
    }

    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }

    this.setState({ loading: true, msg: "", toastColor: "" });

    let request = {
      categoryName: this.state.category,
      uniqueIdentifier: this.state.uniqueIdentifier,
      companyProfileId: parseInt(this.state.companyProfileId) || 0,
      individualProfileId: parseInt(this.state.individualProfileId) || 0,
      searchCost: this.state.searchCost || 0,
    };

    axios
      .post(API + "/asset/search", request, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        this.setState({
          assets: response.data || [],
          loading: false,
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          assets: [],
          loading: false,
          msg:
            error?.response?.data?.message ||
            "Search failed. Please try again.",
          toastColor: "danger",
        });
      });
  }

  handleUploadSearch(e) {
    e.preventDefault();
    if (!this.state.assetFile) {
      this.setState({
        msg: "Please select a file to upload.",
        toastColor: "danger",
      });
      return;
    }

    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }

    this.setState({ loading: true, msg: "", toastColor: "" });

    let request = new FormData();
    request.append("file", this.state.assetFile);
    if (Number(sessionStorage.getItem("companyProfileId"))) {
      request.companyProfileId = sessionStorage.getItem("companyProfileId");
    }
    if (Number(sessionStorage.getItem("individualProfileId"))) {
      request.individualProfileId = sessionStorage.getItem(
        "individualProfileId"
      );
    }
    if (Number(sessionStorage.getItem("lawEnforcementProfileId"))) {
      request.lawEnforcementProfileId = sessionStorage.getItem(
        "lawEnforcementProfileId"
      );
    }

    axios
      .post(API + "/asset/searchupload", request, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.data.success) {
          this.setState({
            assets: response.data.assetGenericViews || [],
            loading: false,
          });
        } else {
          this.setState({
            assets: response.data.assetGenericViews || [],
            loading: false,
            errors: { assetFile: response.data.message || "Failed to search" },
            toastColor: "danger",
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          assets: [],
          loading: false,
          msg:
            error?.response?.data?.message ||
            "Upload search failed. Please try again.",
          toastColor: "danger",
        });
      });
  }

  handlePrint(id, pdfTemplateType) {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }

    if (!pdfTemplateType) {
      this.setState({
        msg: "Asset has no defined print type. Contact administrator",
        toastColor: "danger",
      });
      return;
    }

    axios
      .get(API + "/pdf/getprintout/" + id + "/" + pdfTemplateType, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        this.setState({
          printData: response.data.data,
          loading: false,
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          assets: [],
          loading: false,
          msg:
            error?.response?.data?.message ||
            "Search failed. Please try again.",
          toastColor: "danger",
        });
      });
    this.setState({ showPrintModal: true });
  }
  closePrint() {
    this.setState({ showPrintModal: false });
  }
  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    if (s.loading) {
      return <Spinner className="" />;
    }

    return (
      <div className="min-vh-100 d-flex justify-content-between bg-white">
        <Sidebar />
        <div className="min-vh-100 flex-grow-1 d-flex flex-column">
          <Banner title="Search Asset" />
          {divMsg}
          <div className="w-100 flex-grow-1 px-5 d-flex flex-column justify-content-start">
            <div className="w-100 ">
              <form
                className="row g-2 w-100"
                autoComplete="off"
              >
                <div className="input-group col-span-5">
                  <label className="input-group-text">Category</label>
                  <select
                    name="category"
                    className="form-control"
                    value={s.category}
                    onChange={this.handleChange}
                  >
                    <option value="">Select</option>
                    {s.categories.map((cat, index) => (
                      <option key={index} value={cat}>
                        {cat}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="input-group col-span-5">
                  <label className="input-group-text">Unique Identifier</label>
                  <input
                    name="uniqueIdentifier"
                    className="form-control"
                    type="text"
                    value={s.uniqueIdentifier}
                    onChange={this.handleChange}
                    placeholder="Enter unique identifier"
                  />
                </div>
                <button
                  type="button"
                  className="btn btn-primary col-span-2"
                  onClick={this.handleSearch}
                  disabled={!s.valid}
                >
                  Search
                </button>
                <span className="col-span-full fw-bold text-danger">
                  * For search with file, put unique identifier in first column,
                  without headers
                </span>
                <div className="input-group col-span-8">
                  <label className="input-group-text">Asset Search File</label>
                  <input
                    name="assetFile"
                    className="form-control"
                    type="file"
                    onChange={this.handleFileChange}
                    accept=".xlsx"
                  />
                  {s.errors.assetFile && (
                    <span className="input-group-error">
                      {s.errors.assetFile}
                    </span>
                  )}
                </div>
                <button
                  type="button"
                  className="btn btn-primary col-span-2"
                  onClick={this.handleUploadSearch}
                  disabled={!s.assetFile}
                >
                  Upload & Search
                </button>

                {s.errors.search && (
                  <div className="alert alert-danger mx-7 mb-4 col-span-full">
                    {s.errors.search}
                  </div>
                )}
              </form>

              {s.assets.length > 0 && (
                <div className="w-100 overflow-auto border mt-4">
                  <table className="table table-striped table-hover rounded">
                    <thead className="table-primary">
                      <tr>
                        <th className="px-6 py-3 text-left text-xs fw-medium text-muted uppercase tracking-wider">
                          Category
                        </th>
                        <th className="px-6 py-3 text-left text-xs fw-medium text-muted uppercase tracking-wider">
                          Unique Identifier
                        </th>
                        <th className="px-6 py-3 text-left text-xs fw-medium text-muted uppercase tracking-wider">
                          Status
                        </th>
                        <th className="px-6 py-3 text-left text-xs fw-medium text-muted uppercase tracking-wider">
                          Make
                        </th>
                        <th className="px-6 py-3 text-left text-xs fw-medium text-muted uppercase tracking-wider">
                          Model
                        </th>
                        <th className="px-6 py-3 text-left text-xs fw-medium text-muted uppercase tracking-wider">
                          Ownership
                        </th>
                        <td></td>
                      </tr>
                    </thead>
                    <tbody className="">
                      {s.assets.map((asset) => (
                        <tr
                          key={`asset-${asset.id}`}
                          className="hover:bg-gray-50"
                        >
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-dark">
                            {asset.categoryName || "-"}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-dark">
                            {asset.uniqueIdentifier || "-"}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-dark">
                            {asset.primaryStatus || "-"}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-dark">
                            {asset.primaryName || "-"}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-dark">
                            {asset.secondaryName || "-"}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-dark">
                            {asset.ownershipName || "-"}
                          </td>
                          <td>
                            {" "}
                            <button
                              type="button"
                              className="link-primary link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover cursor-pointer"
                              onClick={() =>
                                this.handlePrint(
                                  asset.id,
                                  asset.pdfTemplateType
                                )
                              }
                            >
                              Print Ownership Certificate
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {s.assets.length > 0 && (
                <div className="d-flex justify-content-center mt-6"></div>
              )}

              {s.assets.length === 0 && s.msg === "" && (
                <div className="text-muted text-center py-8">
                  No search results found. Use the search form above to find
                  assets.
                </div>
              )}
            </div>
          </div>
          
        </div>
        {s.showPrintModal && (
          <Modal
            title="Print"
            footerContent={
              <>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => this.closePrint()}
                >
                  Close
                </button>
              </>
            }
          >
            {s.printData !== "" && (
              <iframe
                title="PDF View"
                src={"data:application/pdf;base64," + s.printData}
                type="application/pdf"
                style={{ width: 100 + "%", height: 500 + "px" }}
              ></iframe>
            )}
          </Modal>
        )}
      </div>
    );
  }
}
